// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type ToolConfigListe } from "../../api";
import { useGetToolConfigsForPhoneNumber as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useToolConfigsForPhoneNumberQueryKey(
  phoneNumberId: string,
  toolId: string
): QueryKey {
  return [
    "api",
    "v1",
    "phonenumbers",
    phoneNumberId,
    "tools",
    toolId,
    "configs",
  ];
}

export function useToolConfigsForPhoneNumber(
  phoneNumberId: string,
  toolId: string,
  options: Omit<
    UseQueryOptions<ToolConfigListe, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): ToolConfigListe {
  const getter = useGetter();
  return useQuery(
    useToolConfigsForPhoneNumberQueryKey(phoneNumberId, toolId),
    () => getter(phoneNumberId, toolId),
    options
  ).data!;
}
